import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IHouseExpense, defaultValue } from 'app/shared/model/house-expense.model';
// 请求
export const ACTION_TYPES = {
  FETCH_HOUSEEXPENSE_LIST: 'houseExpense/FETCH_HOUSEEXPENSE_LIST',
  FETCH_HOUSEEXPENSE: 'houseExpense/FETCH_HOUSEEXPENSE',
  CREATE_HOUSEEXPENSE: 'houseExpense/CREATE_HOUSEEXPENSE',
  UPDATE_HOUSEEXPENSE: 'houseExpense/UPDATE_HOUSEEXPENSE',
  DELETE_HOUSEEXPENSE: 'houseExpense/DELETE_HOUSEEXPENSE',
  RESET: 'houseExpense/RESET'
};
// state类型
const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IHouseExpense>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false
};

export type HouseExpenseState = Readonly<typeof initialState>;

// Reducer

export default (state: HouseExpenseState = initialState, action): HouseExpenseState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_HOUSEEXPENSE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_HOUSEEXPENSE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true
      };
    case REQUEST(ACTION_TYPES.CREATE_HOUSEEXPENSE):
    case REQUEST(ACTION_TYPES.UPDATE_HOUSEEXPENSE):
    case REQUEST(ACTION_TYPES.DELETE_HOUSEEXPENSE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case FAILURE(ACTION_TYPES.FETCH_HOUSEEXPENSE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_HOUSEEXPENSE):
    case FAILURE(ACTION_TYPES.CREATE_HOUSEEXPENSE):
    case FAILURE(ACTION_TYPES.UPDATE_HOUSEEXPENSE):
    case FAILURE(ACTION_TYPES.DELETE_HOUSEEXPENSE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_HOUSEEXPENSE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.FETCH_HOUSEEXPENSE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.CREATE_HOUSEEXPENSE):
    case SUCCESS(ACTION_TYPES.UPDATE_HOUSEEXPENSE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data
      };
    case SUCCESS(ACTION_TYPES.DELETE_HOUSEEXPENSE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {}
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = 'api/house-expenses';

// Actions

export const getEntities: ICrudGetAllAction<IHouseExpense> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_HOUSEEXPENSE_LIST,
  payload: axios.get<IHouseExpense>(`${apiUrl}?cacheBuster=${new Date().getTime()}`)
});

export const getEntity: ICrudGetAction<IHouseExpense> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_HOUSEEXPENSE,
    payload: axios.get<IHouseExpense>(requestUrl)
  };
};

export const createEntity: ICrudPutAction<IHouseExpense> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_HOUSEEXPENSE,
    payload: axios.post(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IHouseExpense> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_HOUSEEXPENSE,
    payload: axios.put(apiUrl, cleanEntity(entity))
  });
  dispatch(getEntities());
  return result;
};

export const deleteEntity: ICrudDeleteAction<IHouseExpense> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_HOUSEEXPENSE,
    payload: axios.delete(requestUrl)
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});
